import { callApi } from "Apis";
import { AMENITYURL } from "helpers/constant";

export async function amenityList(data) {
  try {
    const response = await callApi({ url: AMENITYURL.LIST, body: data, method: "POST" });
    return response;
  } catch (err) {
    throw err;
  }
}

export async function amenityAdd(data) {
  try {
    const response = await callApi({ url: AMENITYURL.ADD, body: data, method: "POST" });
    return response;
  } catch (err) {
    throw err;
  }
}

export async function getAmenityById(id) {
  try {
    const response = await callApi({ url: AMENITYURL.GET(id), method: "GET" });
    return response;
  } catch (err) {
    throw err;
  }
}
export async function updateAmenity(data) {
  try {
    const response = await callApi({ url: AMENITYURL.UPDATE, body: data, method: "PUT" });
    return response;
  } catch (err) {
    throw err;
  }
}

export async function deleteAmenityById(id) {
  try {
    const response = await callApi({ url: AMENITYURL.DELETE(id), method: "DELETE" });
    return response;
  } catch (err) {
    throw err;
  }
}

export async function amenityOption(data) {
  try {
    const response = await callApi({ url: AMENITYURL.OPTION, body: data, method: "POST" });
    return response;
  } catch (err) {
    throw err;
  }
}

export async function checkAmenityAvailable(data) {
  try {
    const response = await callApi({ url: AMENITYURL.AVAILABLE, body: data, method: "POST" });
    return response;
  } catch (err) {
    throw err;
  }
}

export async function bookAmenity(data) {
  try {
    const response = await callApi({ url: AMENITYURL.BOOK, body: data, method: "POST" });
    return response;
  } catch (err) {
    throw err;
  }
}

export async function amenityBookingList(data) {
  try {
    const response = await callApi({ url: AMENITYURL.BOOKING_LIST, body: data, method: "POST" });
    return response;
  } catch (err) {
    throw err;
  }
}

export async function updateAmenityBookingList(data) {
  try {
    const response = await callApi({ url: AMENITYURL.UPDATE_BOOKING, body: data, method: "PUT" });
    return response;
  } catch (err) {
    throw err;
  }
}

export async function amenityBookingCalenderList(data) {
  try {
    const response = await callApi({ url: AMENITYURL.CALENDER_LIST, body: data, method: "POST" });
    return response;
  } catch (err) {
    throw err;
  }
}

export async function updateSettleDeposit(data) {
  try {
    const response = await callApi({ url: AMENITYURL.SETTLE_DEPOSIT, body: data, method: "PUT" });
    return response;
  } catch (err) {
    throw err;
  }
}
